import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Icon, Label, Tooltip, Utils } from 'mw-style-react';
import useIntl from 'useIntl';
import cn from 'classnames';
import './FormSectionsPanel.scss';
import mes from './intl';

/**
 * Панель со списком секций формы
 */
function FormSectionsPanel({ formRef, sections, activeSection, onSelect }) {
  const t = useIntl();
  const [isOpen, togglePanel] = useState(true);

  const handleClickSection = (value) => {
    onSelect({ value });
    if (!formRef.current) return;
    const isActive = value === activeSection;
    setTimeout(() => {
      const container = ReactDOM.findDOMNode(formRef.current);
      const activeSectionEl = container.childNodes[value + 1];
      const scrollPos = activeSectionEl ? activeSectionEl.offsetTop - 54 : 0;
      // если секция уже активна, но свернута - клик для раскрытия
      if (isActive && activeSectionEl.childNodes.length === 1) {
        activeSectionEl.querySelector('i').click();
      }
      Utils.scrollTo(container, scrollPos, 200);
    }, 400);
  };

  const renderTotalErrors = () => {
    const count = sections.reduce((sum, elem) => {
      return sum + elem.content.filter((i) => i.error).length;
    }, 0);

    if (!count) return null;
    return (
      <Tooltip
        styleName="sections__panel__item__error__tooltip"
        value={count > 1 ? t(mes.errorsFound, { count }) : t(mes.errorFound)}
      >
        <div
          styleName="sections__panel__item__error total"
          onClick={() => togglePanel((prevOpen) => !prevOpen)}
        >
          <Label value={count} />
          <Icon type="alert" />
        </div>
      </Tooltip>
    );
  };

  const renderError = (count) => {
    if (!count) return null;
    return (
      <Tooltip
        styleName="sections__panel__item__error__tooltip"
        value={count > 1 ? t(mes.errorsFound, { count }) : t(mes.errorFound)}
      >
        <div styleName="sections__panel__item__error">
          <Label value={count} />
          <Icon type="alert" />
        </div>
      </Tooltip>
    );
  };

  const renderSectionList = () => {
    if (sections.length === 1 && !sections[0].content.length) {
      return (
        <Label
          styleName="sections__panel__item__empty"
          value={t(mes.formNoSections)}
        />
      );
    }
    return sections.map((item, index) => {
      const errorCount = item.content.filter((i) => i.error).length;
      return (
        <div
          key={index}
          styleName={cn('sections__panel__item', {
            active: activeSection === index,
          })}
          onClick={() => handleClickSection(index)}
        >
          <Label
            fontWeight="normal"
            value={item.title || `Section ${index + 1}`}
          />
          {renderError(errorCount)}
        </div>
      );
    });
  };

  return (
    <div styleName={cn('sections__panel', { open: isOpen })}>
      <Icon
        styleName="sections__panel__icon"
        type="arrows"
        onClick={() => togglePanel((prevOpen) => !prevOpen)}
      />
      {isOpen ? (
        <>
          <Label fontWeight="semibold" value="Navigation" />
          <div
            styleName={cn('sections__panel__item', {
              active: activeSection === -1,
            })}
            onClick={() => handleClickSection(-1)}
          >
            <Label fontWeight="normal" value="Title & description" />
          </div>
          <Label fontWeight="semibold" value="Sections" />
          {renderSectionList()}
        </>
      ) : (
        renderTotalErrors()
      )}
    </div>
  );
}

FormSectionsPanel.propTypes = {
  formRef: PropTypes.object,
  sections: PropTypes.array.isRequired,
  activeSection: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
};

export default FormSectionsPanel;
